export default "<cbs-loan-installments-table [data]=\"installments\"></cbs-loan-installments-table>\r\n"